import { render } from "./PromoContainer.vue?vue&type=template&id=09b0ed3c"
import script from "./PromoContainer.vue?vue&type=script&lang=js"
export * from "./PromoContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PromoContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09b0ed3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09b0ed3c', __exports__)) {
    api.reload('09b0ed3c', __exports__)
  }
  
  module.hot.accept("./PromoContainer.vue?vue&type=template&id=09b0ed3c", () => {
    api.rerender('09b0ed3c', render)
  })

}


export default __exports__